import { createContext, useContext } from 'react';

export interface TocEntry {
  id: string;
  label: string;
}

interface GuideContextValue {
  register: (entry: TocEntry) => void;
  unregister: (id: string) => void;
}

const GuideContext = createContext<GuideContextValue>({
  register: () => {},
  unregister: () => {},
});

export const useGuideContext = () => useContext(GuideContext);
export default GuideContext;
